import React, { Component, Fragment } from "react";
import {Modal} from "../AdministrationLogoutPopup"
import {  withRouter } from "react-router-dom";
class AdministrationMain extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false
    };
  }
  logoutHandler = () => {
    // alert(JSON.stringify( this.props.cookies.get("njt_admin_userId_customer")));
    var data = {
      UserId: this.props.cookies.get("njt_admin_userId_customer").application_user_id
    };
    // alert(data.njt_admin_userId_customer)
    this.props.AdministrationLogout(
      data,
      this.props.cookies.get("admin_token_customer")
    );
    this.closeModel()

  };
  closeModel = ()=>{
    this.setState({
      open: false
    })
  }
  openModel = () =>{
    this.setState({
      open: true
    })
  }
  render() {
    return (
      <Fragment>
       {this.state.open? <Modal onClose = {this.closeModel} onConfirm={this.logoutHandler}/>:null}
        <button id="signOutBtn" className={this.props.className} onClick={this.openModel}>
          Sign Out
        </button>
      </Fragment>
    );
  }
}

export default withRouter(AdministrationMain);
